exports = module.exports = require("../../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shortTips_3sFsCJkD {\n  position: absolute;\n  left: 0.4rem;\n  bottom: 1.013333rem;\n  width: 7.146667rem;\n  height: 0.746667rem;\n  font-size: 0.346667rem;\n  line-height: 0.746667rem;\n  text-align: center;\n  letter-spacing: 0.35px;\n  background: #000000;\n  border-radius: 0.4rem;\n  text-align: center;\n  opacity: 0.8;\n  color: #FFF;\n}\n\n.hairlines .shortTips_3sFsCJkD {\n  letter-spacing: 0.5px;\n}\n\n.fhxwkhd_ZLEa46xl {\n  color: #F54343;\n  font-size: 0.346667rem;\n  line-height: 0.746667rem;\n}", ""]);

// exports
exports.locals = {
	"shortTips": "shortTips_3sFsCJkD",
	"fhxwkhd": "fhxwkhd_ZLEa46xl"
};